import { render, staticRenderFns } from "./RouteConfiguration.vue?vue&type=template&id=3f8fe4a6&"
import script from "./RouteConfiguration.vue?vue&type=script&lang=js&"
export * from "./RouteConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports